import 'angular';

import addDirective from './add/';
import updateDirective from './update/';
import deleteDirective from './delete/';
import callDirective from './call';

const MODULE_NAME = 'daupler.incidents.components.buttons.contacts';

var app = angular.module(MODULE_NAME, [
	'ui.mask',
	'puElasticInput',
	'brg',
	'brg.components.inputs',
]);
app.directive('addContact', addDirective);
app.directive('updateContact', updateDirective);
app.directive('deleteContact', deleteDirective);
app.directive('callContact', callDirective);

export default MODULE_NAME;
